import { render, staticRenderFns } from "./AnnualReport.vue?vue&type=template&id=8ca94498&"
import script from "./AnnualReport.vue?vue&type=script&lang=js&"
export * from "./AnnualReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports